import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { Card } from '../../../shared/components/ui/Card';
import { SettingsForm } from '../components/SettingsForm/SettingsForm';

export default function SettingsPage() {
  const navigate = useNavigate();

  const handleCancel = () => {
    navigate(-1);
  };

  const handleSaved = () => {
    navigate(-1);
  };

  return (
    <Box sx={{ p: { xs: 1, md: 4 }, background: '#F6F8FB', minHeight: '100vh' }}>
      <Card sx={{ background: '#fff', borderRadius: 4, maxWidth: 1200, margin: '32px auto', boxShadow: '0 2px 8px 0 rgba(16,30,54,0.04)' }}>
        <SettingsForm onCancel={handleCancel} onSaved={handleSaved} />
      </Card>
    </Box>
  );
} 